import { render, staticRenderFns } from "./responsibility.vue?vue&type=template&id=30846a26&scoped=true&"
import script from "./responsibility.vue?vue&type=script&lang=js&"
export * from "./responsibility.vue?vue&type=script&lang=js&"
import style0 from "./responsibility.vue?vue&type=style&index=0&id=30846a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30846a26",
  null
  
)

export default component.exports